import React from 'react'

class CopyrightNotice extends React.Component {
    render() {
           let currentYear = new Date().getFullYear().toString()
        return(
            <div>
                <hr/>
                &copy; 2004 - {currentYear} Kris Bruland / Handweaving.net <br/>
            </div>
        )
    }
}

export default CopyrightNotice



// WEBPACK FOOTER //
// ./src/scenes/reducer/components/CopyrightNotice/index.js